import React from "react";
import { FormattedMessage } from "gatsby-plugin-intl";

function Comp_plan_tc() {

    return (
      <div className="text-xs md:text-sm text-center">
        <p className="pt-1">
          <FormattedMessage id="softpos.plan.mdr_tc" defaultMessage="^最終交易費百分比將在審批時按商戶性質及交易情況而定。" />
        </p>
        <p className="pt-1">
          <FormattedMessage id="softpos.plan.date_tc" defaultMessage="†上述特快批核審批日期由收到申請及所需之文件齊備之翌日起計算。" />
        </p>
  </div>
    );
}

export default Comp_plan_tc;